export default "__VITE_ASSET__Dnl7HYui__"